import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Button from "../components/button"

class IndexPage extends React.Component {
  render() {
    const siteTitle = "Байгаль, хүний бүтээсэн гайхамшигууд"

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Нүүр"
          keywords={[`blog`, `gatsby`, `javascript`, `react`]}
        />
        {/* <img style={{ margin: 0 }} src="./GatsbyScene.svg" alt="Gatsby Scene" /> */}
          {/* <span role="img" aria-label="wave emoji">
            👋
          </span> */}
        <p>Энэхүү веб хуудсаас та өдөр бүр нэг гайхамшигийг мэдрээрэй.</p>
        <Link to="/wonders/">
          <Button marginTop="35px">Гайхамшигууд</Button>
        </Link>
      </Layout>
    )
  }
}

export default IndexPage
